import wx from 'weixin-js-sdk'
import {getSignature} from '@/api/index'
import { Toast } from 'vant'
import axios from 'axios'

const wxSdk = {
  install () {
    wxSdk.init()
  },
  init () {
    let url = window.location.href.split('#')[0]
    axios.post(getSignature, {url: url}, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，企业微信的corpID
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      })
      wx.ready(function () {})
      wx.error(function (res) {
        console.log(res)
      })
    }).catch(err => {
      Toast.fail(err.data.msg)
    })
  }
}
export default wxSdk



// WEBPACK FOOTER //
// ./src/assets/js/weixin-sdk.js